module.exports = __webpack_public_path__ + "static/img/6.5860218.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/6.png
// module id = dQVl
// module chunks = 0